﻿import { ColumnsBase, fieldsProxy } from "@serenity-is/corelib";
import { Column } from "@serenity-is/sleekgrid";
import { DocumentsRow } from "./Default.DocumentsRow";

export interface DocumentColumns {
    IsProjectOnlyDocument: Column<DocumentsRow>;
    MyDocuments: Column<DocumentsRow>;
    MyModifications: Column<DocumentsRow>;
    ProjectId: Column<DocumentsRow>;
    Filename: Column<DocumentsRow>;
    ProjectKeyword: Column<DocumentsRow>;
    ProjectContractNo: Column<DocumentsRow>;
    ProjectCustomerName: Column<DocumentsRow>;
    Description: Column<DocumentsRow>;
    Type: Column<DocumentsRow>;
    ModifiedOn: Column<DocumentsRow>;
    CreatedOn: Column<DocumentsRow>;
    ProjectManagerUserId: Column<DocumentsRow>;
    UsageTypeId: Column<DocumentsRow>;
    File: Column<DocumentsRow>;
}

export class DocumentColumns extends ColumnsBase<DocumentsRow> {
    static readonly columnsKey = 'DocumentManagement.Document';
    static readonly Fields = fieldsProxy<DocumentColumns>();
}